import React from "react";
import classes from "./SmallLoader.module.css";

const SmallLoader = () => {
  return (
    <div className={classes.container}>
      <div className={classes.spinner}></div>
    </div>
  );
};

export default SmallLoader;
